"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverSchedulerTransport = exports.DailyScheduleTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const schedule_entry_transport_1 = require("./schedule-entry-transport");
exports.DailyScheduleTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    driverProfileID: typebox_1.Type.String({ format: 'uuid' }),
    date: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    entries: typebox_1.Type.Array(schedule_entry_transport_1.ScheduleEntryTransport),
    metadata: common_1.MetaData,
});
exports.DriverSchedulerTransport = typebox_1.Type.Object({
    unassignedTasks: typebox_1.Type.Array(schedule_entry_transport_1.ScheduleEntryTransport),
    schedules: typebox_1.Type.Array(exports.DailyScheduleTransport),
});
//# sourceMappingURL=daily-schedule-transport.js.map